import {
  UPDATE_STUDENT_REQUEST_START,
  UPDATE_STUDENT_REQUEST_SUCCESS,
  UPDATE_STUDENT_REQUEST_FAILURE,
} from "../Actions/studentRequestUpdateAction";

const initialState = {
  loading: false,
  error: null,
  message: null,
};

export const studentRequestUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STUDENT_REQUEST_START:
      return { ...state, loading: true, error: null, message: null };
    case UPDATE_STUDENT_REQUEST_SUCCESS:
      return { ...state, loading: false, message: action.payload, error: null };
    case UPDATE_STUDENT_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload, message: null };
    default:
      return state;
  }
};
